<ng-container>
  
    <input #file type="file" class="form-control" id="upload-translation"
      (change)="fileChange(file)" multiple>
      <label class="form-label" for="upload-translation">
        {{ selectedFile == null ? this.translate.instant('COMPONENTS.FILE-INPUT.SELECT-FILE') : selectedFile.name }}
      </label>
    
    <div>
      @for (error of validationErrors; track error) {
        <span class="invalid-feedback"> {{ error.key | translate:error.params }}</span>
      }
    </div>
  </ng-container>
